import React from 'react';
import { Star } from 'lucide-react';
interface T {
  initials: string;
  name: string;
  role: string;
  country: string;
  text: string;
}
const Card = ({
  initials,
  name,
  role,
  country,
  text
}: T) => <div className="brunson-card rounded-lg p-4 md:p-5 flex flex-col h-full" data-id="element-248">
    <div className="flex text-brand-orange mb-2" data-id="element-249">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-250" />)}
    </div>
    <p className="text-sm md:text-base text-brand-ink italic leading-relaxed font-medium flex-grow" data-id="element-251">
      "{text}"
    </p>
    <div className="flex items-center gap-3 mt-3 pt-3 border-t border-brand-line" data-id="element-252">
      <div className="w-11 h-11 rounded-full bg-brand-navy text-white font-display font-bold flex items-center justify-center shrink-0" data-id="element-253">
        {initials}
      </div>
      <div data-id="element-254">
        <p className="font-display font-bold text-brand-navy text-sm uppercase leading-tight" data-id="element-255">
          {name}
        </p>
        <p className="text-xs text-brand-mute font-medium" data-id="element-256">
          {role} · {country}
        </p>
      </div>
    </div>
  </div>;
export function Testimonials() {
  const items: T[] = [{
    initials: 'RM',
    name: 'Ing. Roberto Méndez',
    role: 'Escuela Agrotécnica · 48 años',
    country: 'Entre Ríos',
    text: 'Antes pasaba mis vacaciones planeando el curso. Ahora abro la Planificación del Bono 4, la ajusto en 20 minutos y listo. Mis alumnos aprenden más y yo duermo mejor. Recuperé los domingos con mi familia.'
  }, {
    initials: 'LE',
    name: 'Profa. Lucía Espinoza',
    role: 'Capacitadora Técnica · 41 años',
    country: 'Chaco',
    text: 'El Tomo 5 de Sanidad les voló la cabeza a los chicos. Por primera vez entienden por qué se mueren los peces y cómo prevenirlo. El protocolo de necropsia lo hicimos con un sábalo del mercado. Fue épico.'
  }, {
    initials: 'MT',
    name: 'Téc. Marcos Tincopa',
    role: 'Instructor de Campo · 52 años',
    country: 'Salta',
    text: 'Llevo 15 años en el sector y nunca vi material tan bien armado. Las tablas del Tomo 4 sobre FCR las uso hasta yo en mi propio criadero de tilapia. Pagué los $21.990 y la primera semana ya recuperé el doble en horas que no perdí buscando material.'
  }, {
    initials: 'SP',
    name: 'Profa. Sandra Paredes',
    role: 'Escuela Agropecuaria · 38 años',
    country: 'Misiones',
    text: 'Mis colegas me preguntan qué curso hice. Les digo que no fue un curso — fue un sistema. Y el sistema trabaja por vos. Hasta los chicos más difíciles del aula se enganchan con los proyectos prácticos del Bono 3.'
  }, {
    initials: 'DH',
    name: 'Prof. Diego Hernández',
    role: 'Instituto Tecnológico Pesquero · 45 años',
    country: 'Corrientes',
    text: 'Las rúbricas del Bono 2 me salvaron. Ya no discuto con los alumnos sobre las notas. Todo está explicado, criterio por criterio. Y los padres dejaron de mandarme mails quejándose. Vale cada peso que pagué.'
  }];
  return <section className="py-7 px-4 bg-brand-creamAlt border-y-2 border-brand-line" data-id="element-257">
      <div className="max-w-6xl mx-auto" data-id="element-258">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy text-center uppercase mb-5 leading-tight" data-id="element-259">
          Lo que dicen los <span className="green-highlight" data-id="element-260">docentes:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-261">
          {items.map((t, i) => <Card key={i} {...t} data-id="element-262" />)}
        </div>
      </div>
    </section>;
}